import * as React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';

export interface FilterOption {
  label: string;
  value: string | boolean | null;
}

export interface FilterDropdownProps {
  options: FilterOption[];
  value?: string | boolean | null;
  onValueChange?: (value: string | boolean | null) => void;
  placeholder?: string;
  className?: string;
}

const FilterDropdown = React.forwardRef<HTMLButtonElement, FilterDropdownProps>(
  ({ options, value, onValueChange, placeholder = 'Filter', className }, ref) => {
    const selectedOption = options.find(option => option.value === value);

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            ref={ref}
            variant="outline"
            className={cn('justify-between', className)}
          >
            {selectedOption ? selectedOption.label : placeholder}
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[200px]">
          {options.map((option, index) => (
            <DropdownMenuItem
              key={index}
              onClick={() => onValueChange?.(option.value)}
              className="flex items-center justify-between"
            >
              {option.label}
              {value === option.value && (
                <Check className="h-4 w-4" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
);

FilterDropdown.displayName = 'FilterDropdown';

export { FilterDropdown };